<script setup>
  import SeoTextService from '@/Components/General/SeoTextService.vue'
  import WhyChoose from '@/Components/General/WhyChoose.vue'
  import HowWork from '@/Components/General/HowWork.vue'
  import HowBuy from '@/Components/General/HowBuy.vue'
  import AppLayout from "@/Layout/AppLayout.vue";
  import { usePage } from '@inertiajs/vue3'
  import {trans} from "@/Utils/translation.utils.js";
  import { ref } from 'vue';
  const props = defineProps({
      items: [Array,Object],
      buttonColor: {
        type:String,
        default:null
        }
  })

  const getFirstMenuIndex = () => {
      if (!props.items.submenu) return 0
      const keys = Object.keys(props.items.submenu)
      return keys.length > 0 ? parseInt(keys[0]) : null
  }

  const activeTab = ref(getFirstMenuIndex())
  const seoData = usePage().props.seo_data

</script>

<template>
  <AppLayout>
      <section class="service-page">
          <div class="container">
              <h1 class="page-title mb-4">{{seoData.h1_title}}</h1>
                <div class="tab mb-5">
                    <div class="contents__content">
                        <div class="submenu-tabs">
                            <template v-for="(menu, index) in items.submenu"  :key="`menu-${index}`">
                                <div class="menu-sublist__link" :class="{ 'is-active': activeTab === parseInt(index) }" @click="activeTab = parseInt(index)">
                                    <img :src="`/img/icons/icon-${menu.icon || 'other'}${activeTab === parseInt(index)  ? '__active' : ''}.svg`" alt=""> {{ menu.title }}
                                </div>
                            </template>
                        </div>

                        <div class="submenu-content">
                            <template v-for="(menu, indexMenu) in items.submenu"  :key="`content-${indexMenu}`">
                                <div v-show="activeTab === parseInt(indexMenu)" class="row align-items-stretch g-0 gx-md-4">
                                    <template v-for="(item, indexSub) in menu.submenu" :key="`item-${indexSub}`">
                                        <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                                            <a :href="item.link" class="service-list-item c-card c-card--hovered">
                                                <img class="service-list-item__img mb-3" :src="item.icon" :alt="item.title" width="72">
                                                <span class="service-list-item__title mb-3">
                                                    {{ item.title }}
                                                </span>
                                                <button class="service-list-item__btn btn btn-outline-primary" :class="buttonColor">{{trans('front.view-pricing')}}</button>
                                            </a>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
              <SeoTextService />
          </div>
          <WhyChoose />
          <HowWork />
          <HowBuy />
      </section>
  </AppLayout>
</template>

<style lang="scss" scoped>
  .service-page {
    padding-top: 1.25rem;
    .service-list-item {
      min-height: 252px;
    }
  }

  .service-list-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 1.5rem 1rem;
    font-family: 'Ruda', 'Montserrat', sans-serif;
    height: 100%;

    &:hover {
      text-decoration: none;
    }

    &__title {
      font-size: 1.25rem;
      font-weight: 800;
    }

    &__btn {
      transition: none;
      &:hover {
        border-color: #1e73be;
        background-color: #1e73be;
      }
    }
  }
</style>
